import { render, staticRenderFns } from "./ServiceCommissionRuleEditor.vue?vue&type=template&id=52a8010e&scoped=true"
import script from "./ServiceCommissionRuleEditor.vue?vue&type=script&lang=js"
export * from "./ServiceCommissionRuleEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a8010e",
  null
  
)

export default component.exports